module.exports = __webpack_public_path__ + "assets/img/order-head-back3.761f4592.png";